<deprecated-callout
  *deprecated-callout
  [anchor]="anchor"
  [preferredPosition]="preferredPosition"
  (close)="delayClear()"
>
  <div class="list" [style.width]="width">
    <div
      class="list__item"
      #listItem
      *ngFor="let item of list; let i = index"
      [class.list__item--selected]="i == selectedItem"
      [class.disabled]="item.disabled"
      (click)="selectedItem = i; selected.emit(item)"
    >
      {{ item.description != null ? item.description : item.text }}
      <span class="subtext">{{ item.subtext }}</span>
    </div>
  </div>
</deprecated-callout>
